import { Badge } from "@mantine/core";
import { useIsPendingWithdraw } from "src/generator/hooks/useIsPendingWithdraw";
import { entryStatusMap } from "src/utils/entryStatus";

import useNonMaritime from "../../../hooks/useNonMaritime";

interface IStatusBadge {
  status: number | string;
  size?: string;
  variant?: string;
  autosave?: number;
  id?: string;
}

export const statusList = entryStatusMap;

const StatusBadge = ({
  status,
  size = "lg",
  variant = "light",
  autosave,
  id,
}: IStatusBadge) => {
  const isPendingWithdraw = useIsPendingWithdraw(id);
  const { replaceMaritimeText } = useNonMaritime();

  if (isPendingWithdraw) {
    return (
      <Badge variant={variant} size={size} color="red" py={10} miw={80}>
        To Withdraw
      </Badge>
    );
  }

  if (typeof status === "string") {
    return (
      <Badge variant={variant} size={size} color={"blue"} py={10} miw={80}>
        {status}
      </Badge>
    );
  }

  const item = statusList[status];
  if (!item) return <></>;
  return (
    <Badge
      variant={variant}
      size={size}
      color={item.color ?? "blue"}
      py={10}
      miw={item.miw ?? 100}>
      {replaceMaritimeText(item.label)}
    </Badge>
  );
};

export default StatusBadge;
